import React from 'react';
import { connect } from 'react-redux';

const iframeHeight = 730;

const Typeform = React.memo( ( {
  className, src, locale,
} ) => {
  const cl = `embed-responsive ${className || ''}`;

  const s = {
    es: '',
    en: '',
    ...src,
  };

  return (
    <div className={cl} style={{ height: iframeHeight }}>
      <iframe
        className="xembed-responsive-item"
        src={s[locale.locale]}
        title="Massphoning"
        allowFullScreen
        frameBorder="0"
        height={iframeHeight}
      />
    </div>
  );
} );

const mapStateToProps = ( { settings } ) => ( {
  locale: settings.locale,
} );

export default connect( mapStateToProps, null )( Typeform );
